<div class="backdrop-wrapper">
  <div class="backdrop"></div>
  <div class="change-password-modal">
    <div class="header" [class.confirmed]="store.confirmedPassword()">
      @if (store.confirmedPassword()) {
      <button mat-icon-button (click)="store.resetConfirmedPassword()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2 class="title top-title">{{
        'changeYourPassword' | translate | async
      }}</h2>
      }
      <button
        mat-icon-button
        tabindex="-1"
        (click)="store.closeDialog(dialogRef!)"
        aria-label="Close"
        class="close-button"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    @if (store.confirmedPassword()) {
    <mat-divider class="divider"></mat-divider>
    }

    <div class="form-wrapper">
      <div class="form-container">
        @if (store.forgotPassword()) {
        <app-reset-forgotten-password />
        } @else if (store.confirmedPassword()) {
        <app-confirm-password />
        } @else {
        <h2 class="title">{{ 'changeYourPassword' | translate | async }}</h2>
        <p class="subtitle">{{ 'verifyPassword' | translate | async }}</p>
        <form
          [formGroup]="store.passwordForm"
          (ngSubmit)="onSubmitOldPassword()"
          class="form"
        >
          <app-password-input
            [form]="store.passwordForm"
            controlName="oldPassword"
            [labelText]="('enterCurrentPassword' | translate | async) ?? ''"
          />
          <div class="actions">
            <button
              mat-button
              tabindex="-1"
              type="button"
              (click)="store.enterForgotMode()"
            >
              {{ 'forgotPassword' | translate | async }}
            </button>
            <button
              mat-flat-button
              tabindex="-1"
              color="primary"
              type="submit"
              [disabled]="store.passwordForm.controls.oldPassword.invalid"
              class="next-button"
            >
              {{ 'next' | translate | async }}
            </button>
          </div>
        </form>
        }
      </div>
    </div>
  </div>
</div>
